var mbkpt = '992';

$(function(){ 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: mbkpt,
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  $('a:not([role=tab])').on('click', function(event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        //$target.focusWithoutScrolling();
        $('html, body').animate({
          scrollTop: target.offset().top - 150
        }, 700);
        $('.collapse-button').removeClass('expanded').children('i').removeClass('fa-times').addClass('fa-bars');
        $('.slimmenu.collapsed').hide();
      }
    }
  });
});

// Run MobileInit on ready, as well as on resize
$(mobileInit);
$(window).on('resize',mobileInit);

function mobileInit() {
  // Moves items on Navigation collapse to mobile
  $('[data-move-to]').each(function(){
    var breakpoint;
    var moveto      = $(this).data('move-to');
    var method      = $(this).data('move-method');
    var ww          = $(window).width();
    var movefrom    = this.id;

    if($(this).data('move-breakpoint') != null){
      breakpoint = $(this).data('move-breakpoint');
    } else {
      breakpoint = mbkpt;
    }

    if(ww < breakpoint){
      $(this).wrap($('<span>').attr('data-ref', movefrom));
      
      if(method == 'prepend'){
        $(moveto).prepend($(this));
      } else {
        $(moveto).append($(this));
      }

      $(this).attr('data-move-from', movefrom).removeAttr('data-move-to').show();
    }
  });
  $('[data-move-from]').each(function(){
    var breakpoint;
    var movefrom    = $(this).data('move-from');
    var moveto      = $(this).parent().attr('id');
    var ww          = $(window).width();

    if($(this).data('move-breakpoint') != null){
      breakpoint = $(this).data('move-breakpoint');
    } else {
      breakpoint = mbkpt;
    }

    if(ww > breakpoint){
      $('span[data-ref="' + movefrom + '"]').replaceWith($('#' + movefrom));
      $(this).attr('data-move-to', '#' + moveto).removeAttr('data-move-from');
    }
  });
}